export default "<p>pending-approval-detail-table works!</p>"